export const BOOKING_URL = process.env.REACT_APP_BOOKING_URL;

export function openBooking() {
  window.location.assign(BOOKING_URL);
}